<template>
  <div class="body_">
    <div class="body_banner">
      <img class="bb_img" src="../../assets/ath_banner.png" />
      <div class="bb_abs">
        <div class="bb_logo">
          <img class="bb_img" src="../../assets/ath_logo.png" />
          标识山西认证中心
        </div>
        <div class="bb_title">专属官方身份标识，享多重认证权益！</div>
        <div class="bb_list">
          <div style="width: 1.96rem">
            <img src="../../assets/ath_b1.png" />
            <p class="bb_list_1">点亮 <span>认证标识</span></p>
            <p class="bb_list_2">专属认证图标，提升账号权威性 吸引更多关注者</p>
          </div>
          <div style="width: 2.52rem">
            <img src="../../assets/ath_b2.png" />
            <p class="bb_list_1">获得 <span>官方推荐</span></p>
            <p class="bb_list_2">
              全面流量扶持机制，优质作品更快被发现
              千万级曝光平台，让更多人看见你的作品
            </p>
          </div>
          <div style="width: 2.24rem">
            <img src="../../assets/ath_b3.png" />
            <p class="bb_list_1">认领 <span>设计订单</span></p>
            <p class="bb_list_2">
              官方领单机会，结算靠谱创作更安心 随时随地领任务，足不出户获高收益
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="body_main">
      <div class="body_main_list">
        <div class="cur" v-for="index in bodyMainList" :key="index" @click="bodyMainListClick(index)">
          <img :src="index.img" />
          <span class="bml_span1">{{ index.title1 }}</span>
          <span class="bml_span2">{{ index.title2 }}</span>
          <span class="bml_span3">{{ index.url ? "去认证" : "敬请期待" }}</span>
        </div>
      </div>
    </div>
    <div class="body_xq">
      <div>常见问题</div>
      <span class="body_xq_span1">为什么要实名认证？</span>
      <span class="body_xq_span2">实名认证后，个人主页会有「实名」标识，让潜在合作方找到你的时候，更安心、更放心。</span>
      <span class="body_xq_span1">申请「个人身份认证」的条件有哪些？</span>
      <span class="body_xq_span2">完成「实名」认证后，提交相关证明材料皆可申请。需保证标识山西个人主页最近28天发布公开作品数≥1部，需要有自己的代表作和一定行业从业经验。</span>
      <span class="body_xq_span1">个人身份认证后能否修改昵称，如何修改？</span>
      <span class="body_xq_span2">需要重新提交认证申请，申请通过后即可更改昵称。</span>
      <span class="body_xq_span1">申请「机构认证」的条件有哪些？</span>
      <span class="body_xq_span2">需要是实名认证状态，是品牌主或行业相关机构/组织。申请机构认证时保证标识山西最近28天发布公开作品数≥1部。</span>
      <span class="body_xq_span1">机构认证后能否修改机构名称，如何修改？</span>
      <span class="body_xq_span2">可以申请修改，前往“个人设置”——“个人资料”修改并提交申请，审核成功后生效。</span>
      <span class="body_xq_span1">认证周期需要多久？</span>
      <span class="body_xq_span2">一般需要1-5个工作日，认证审核结果会通过系统私信告知。私信中，会明确您审核通过结果或失败原因</span>
      <span class="body_xq_span1">进行加V认证和实名认证都可以上传作品，那么进行加V认证有什么好处？</span>
      <span class="body_xq_span2">加V认证后可以在标识山西通过职业和属性被筛选到，增大曝光量和匹配度。</span>
      <span class="body_xq_span1">认证资质是永久有效的吗？</span>
      <span class="body_xq_span2">不是所有的认证资质都是永久有效的，具体情况要看不同的认证类型，以及平台具体安排。</span>
      <span class="body_xq_span1">标识山西认证创作人是否可以修改成机构认证？</span>
      <span class="body_xq_span2">认证成功后无法修改，请谨慎选择。</span>
      <span class="body_xq_span1">标识山西认证创作人/机构认证是否可以取消？</span>
      <span class="body_xq_span2">在平台无升级调整的情况下，用户认证成功后无法取消，请谨慎选择。</span>
      <span class="body_xq_span1">加V认证是否需要进行实名认证？</span>
      <span class="body_xq_span2">「创作人认证」、「机构认证」、「联盟认证」均需要先进行实名认证。</span>
      <span class="body_xq_span1">新注册的账号想要进行实名认证，但实名信息已经被其他账号认证过了怎么办？</span>
      <span class="body_xq_span2">一个实名信息仅可认证一个账号。如需新账号进行实名，需要注销实名认证过的其他账号，实名信息释放后再进行认证。</span>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
document.title = "标识山西-认证中心";
const bodyMainList = ref([
  {
    img: require("../../assets/ath_list1.png"),
    title1: "极速实名认证",
    title2: "个人用户真实身份确认",
    url: "/AuthenTication",
    params: "first",
  },
  {
    img: require("../../assets/ath_list2.png"),
    title1: "创作人认证",
    title2: "标识山西创作人职业身份认证",
    url: "/AuthenTication",
    params: "second",
  },
  {
    img: require("../../assets/ath_list3.png"),
    title1: "企业认证",
    title2: "公司、机构、工作室、媒体等认证",
    url: "/AuthenTication",
    params: "third",
  },
  {
    img: require("../../assets/ath_list4.png"),
    title1: "联盟认证",
    title2: "企业Plus角色身份认证",
    url: false,
  },
]);
const bodyMainListClick = function (index) {
  if (index.url) {
    router.push({
      path: index.url,
      query: { type: index.params, num: "3" },
    });
  }
};
</script>
<style scoped>
.body_ {
  width: 100%;
}

.body_banner {
  width: 100%;
  position: relative;
}

.bb_img {
  width: 100%;
}

.bb_abs {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.8rem;
}

.bb_logo {
  font-size: 0.48rem;
  font-weight: bold;
  line-height: 0.56rem;
  background: linear-gradient(0deg, #2455f4 0%, #6194fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.16rem;
}

.bb_logo>img {
  width: 0.84rem;
}

.bb_title {
  margin-bottom: 0.4rem;
  font-size: 0.24rem;
  color: #333333;
  line-height: 0.28rem;
  font-weight: 300;
}

.bb_list {
  display: flex;
}

.bb_list>div {
  margin-right: 0.3rem;
}

.bb_list>div>img {
  width: 0.6rem;
}

.bb_list_1 {
  color: #333;
  font-size: 0.2rem;
  margin-top: 0.16rem;
  margin-bottom: 0.08rem;
}

.bb_list_1>span {
  color: #2c5af4;
  font-size: 0.2rem;
}

.bb_list_2 {
  font-size: 0.14rem;
  color: #333333;
  line-height: 0.28rem;
  font-weight: 400;
}

.body_main {
  width: 12rem;
  margin: 0 auto;
  padding-top: 0.6rem;
}

.body_main_list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.6rem;
}

.body_main_list>div {
  width: 2.7rem;
  background: #f7f9fa;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  padding: 0.4rem 0;
}

.body_main_list>div>img {
  width: 0.8rem;
  margin: 0 auto;
  margin-bottom: 0.24rem;
  display: block;
}

.body_main_list>div>span {
  display: block;
  text-align: center;
}

.bml_span1 {
  color: #333;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 0.16rem;
  margin-bottom: 0.04rem;
}

.bml_span2 {
  color: #86909c;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.14rem;
  margin-bottom: 0.32rem;
}

.bml_span3 {
  color: #333333;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 0.16rem;
}

.body_xq {
  width: 12rem;
  margin: 0 auto;
  padding: 0.4rem 1.33rem;
  border: 0.01rem solid #e5e6eb;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  margin-bottom: 0.47rem;
  box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.25);
}

.body_xq>span {
  display: block;
}

.body_xq>div {
  color: #000000;
  font-size: 0.24rem;
  line-height: 0.28rem;
  text-align: center;
  margin-bottom: 0.4rem;
}

.body_xq_span1 {
  font-weight: 400;
  line-height: 0.19rem;
  font-size: 0.16rem;
  color: #333333;
  margin-bottom: 0.12rem;
}

.body_xq_span2 {
  font-size: 0.14rem;
  font-weight: 400;
  color: #86909c;
  line-height: 0.16rem;
  margin-bottom: 0.24rem;
}
</style>
